import React from 'react'

export const ProductNotFound = () => {
    return (
        <div className = 'detail_not_found'>No encontramos ningun producto</div>
    )
}
